import { Loader, Loader2 } from 'lucide-react'

export default function Spinner() {
  return (
    <div className="flex h-5 gap-2">
      <Loader2 className="size-5 animate-spin text-primary" />
    </div>
  )
}
